export const NAME = 'didomi';
export const noticeID = 'D9fNtHCe';
